import { submitImportableAssets } from './Effects'

export const SELECT_ASSETS = 'SELECT_ASSETS'

export const createActions = (dispatch, state) => ({
  toggleAssetSelected: (assetIndex) => {
    const { selectedAssets, holdings } = state
    const assetAlreadySelected = selectedAssets
      .map(asset => asset.index)
      .includes(assetIndex)
    const selectedAsset = holdings.find(holding => holding.index === assetIndex)

    const newSelectedAssets = assetAlreadySelected ? (
      selectedAssets.filter(asset => asset.index !== assetIndex)
    ) : (
      [...selectedAssets, selectedAsset]
    )

    dispatch({
      type: SELECT_ASSETS,
      payload: { selectedAssets: newSelectedAssets },
    })
  },
  deselectAll: () => {
    dispatch({
      type: SELECT_ASSETS,
      payload: { selectedAssets: [] },
    })
  },
  selectAssets: (assets) => {
    dispatch({
      type: SELECT_ASSETS,
      payload: { selectedAssets: assets },
    })
  },
  submitImportableAssets: async () => {
    await submitImportableAssets(state)
  },
})
